import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { GoogleIconWhite } from '@/components/common/icon';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import { OrderStatus } from '@/interface/order';
import {
  isMobile,
  getClerkSignupRedirectUrlPayload,
  buildLoginUrl
} from '@/biz/tool';
import { SignedOut } from '@clerk/clerk-react';

interface Props {
  desc: any;
}

export const LoginDetailBottomButton: React.FC<Props> = ({ desc }) => {
  const [loginButtonDesc, setLoginButtonDesc] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { detailData } = useDetailDataStore();

  useEffect(() => {
    if (detailData?.order?.status === OrderStatus.Invited) {
      setLoginButtonDesc('to join the campaign');
    }
  }, [detailData]);

  const loginUrl = buildLoginUrl({
    ...getClerkSignupRedirectUrlPayload(detailData),
    ahaRedirect: location.pathname + location.search
  });

  return (
    <div className="">
      <SignedOut>
        <div
          role="button"
          tabIndex={0}
          onClick={() => navigate(loginUrl)}
          onKeyDown={(e) => e.key === 'Enter' && navigate(loginUrl)}
          className={`min-h-[42px] px-4 py-2 bg-[#5a31f0] rounded-[999px] justify-center items-center gap-3 inline-flex cursor-pointer
            ${isMobile() ? 'w-[330px]' : 'w-[358px]'}`}
        >
          <GoogleIconWhite className="w-6 h-6" />
          <div className="flex-col justify-center items-start inline-flex">
            <div className="text-white text-base font-semibold font-['Geist'] leading-normal text-nowrap">
              Login with Google
            </div>
            {loginButtonDesc ? (
              <div className="text-white/60 text-xs font-normal font-['Inter']">
                {loginButtonDesc}
              </div>
            ) : null}
          </div>
        </div>
      </SignedOut>
    </div>
  );
};
